// extracted by mini-css-extract-plugin
export default {"starterScreen":"ai","starterImage":"bi","already":"ci","starterImageMobile":"ei","controlX":"fi","starterTextContain":"gi","starterHeader":"hi","starterBtn":"ii","starterSecondaryBtn":"ji","starterBanner":"ki","mobileBtnContainer":"li"};
    if(module.hot) {
      // 1726593102869
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  